{
  "en": {
    "modal": {
      "actions": {
        "add": "Assign this customer to this unit",
        "approve": "Approve",
        "assign": "Assign to this unit",
        "assign_SUP": "Assign to this project",
        "block": "Block",
        "cancel": "Cancel",
        "close": "Close",
        "contact_ziggu": "Contact Ziggu",
        "deactivate": "Deactivate",
        "giveAccess": "Give online access",
        "goBack": "Go back",
        "gotIt": "Got it",
        "loading": "Loading",
        "next": "Next",
        "no": "No",
        "reactivate": "Reactivate",
        "remove": "Delete",
        "select_rights": "Select rights",
        "send": "Send Email Invitation",
        "sendFeedback": "Send feedback",
        "skip": "Skip",
        "submit": "Submit",
        "submitting": "Submitting",
        "uploading": "Uploading",
        "yes": "Yes"
      },
      "labels": {
        "areYouSure": "Are you sure?",
        "areYouSureDelete": "Are you sure you want to delete {object}?",
        "assignCustomerToUnitMessagePermanently": "{customer} has already been invited to the platform. By assigning this unit, they will have immediate access.",
        "assignCustomerToUnitTitlePermanently": "Assign {customer} permanently to {unit}?",
        "assignTodoListToLevel": "You are about to assign Tasks list {object} to level {level}. Continue?",
        "dangerZone": "Danger zone",
        "deactivate": "Are you sure you want to deactivate {contact}?",
        "deactivateMessage": "The user will be denied access to the platform. All documents, faqs, announcements, tasks, tickets, etc related to this user will remain accessible on the platform for other users.",
        "deleteCustomerMessage": "This person will lose all access to the platform and therefore all documents, FAQs, conversations, news posts, etc.",
        "deleteCustomerTitle": "Are you sure you want to delete customer {customer}?",
        "deleteDecisionsBulk": "Are you sure you want to delete {amount} decisions?",
        "deleteDeniedMessage": "This customer has at least 1 unit assigned to him/her. Remove these assigned units first before deleting this customer.",
        "deleteDeniedTitle": "Delete not permitted for {customer}",
        "deleteEmployeeIntercom": "Contact us through Intercom and we will help you right away!",
        "deleteEmployeeMessage": "This user will lose all access to the platform. All documents, tickets and announcements related to this user will be deleted too.",
        "deleteEmployeeQuestion": "Delete instead?",
        "deleteEmployeeSubMessage": "Please deactive this user instead if you want to keep all his/her information.",
        "deleteEmployeeTitle": "Are you sure you want to remove {employee}?",
        "deleteLeadMessage": "If this lead was interested in a unit you will lose this data. If the lead had bought a unit and became a customer you will keep the customer and its data.",
        "deleteLeadTitle": "Are you sure you want to delete lead {lead}?",
        "goToProposal": "Go to {proposal_name}",
        "gotItMessage": "Ok, got it",
        "loading": "File is being uploaded, please wait. The upload screen will close automatically.",
        "noUnitSelected": "Uh oh! No unit selected",
        "noUnitSelectedMessage": "Select the unit you want to report a defect on",
        "notPossible": "Not possible",
        "ohNo": "Oh no!",
        "reactivate": "Are you sure you want to reactivate {contact}?",
        "reactivateMessage": "The user will gain access to the platform again.",
        "removeCustomerDeleteInfo1": "Conversations that the customer participated in will be deleted",
        "removeCustomerDeleteInfo2": "Surveys related to this unit will be deleted",
        "removeCustomerDeleteInfo3": "Documents uploaded by the customer within conversations, decisions or proposals will be deleted. This also includes signed versions of documents.",
        "removeCustomerKeepInformation": "General documents and any other content published to this unit will remain unchanged and will be visible to a new customer.  ",
        "removeCustomerMessage": "{customer} has had full access to this unit. If you remove the customer, any content by {customer} will be deleted. This means… ",
        "removeCustomerMessageNth": "If you remove this customer, the content created by {customer} will be unattached from {customer}. That means the content will be preserved, but will no longer originate from {customer}.",
        "removeMessage": "Are you sure you want to remove {level}? By doing this you will lose all your saved data related to this {type}. You will not be able to retrieve it afterwards.",
        "removeTitle": "Remove {record_name}",
        "revokeAccessMessage": "You’re about to revoke {customer}’s access to this unit. If this is the customer’s only assigned unit, they will lose complete access to the platform. ",
        "setCustomerMessage": "Great! You’re about to assign {customer} to {unit}. {customer} won’t have full access to the platform yet, though. But you can change that by granting access once you’ve assigned this unit. ",
        "setCustomerMessageSUP": "Great! You’re about to assign {customer} to {unit}. {customer} won’t have full access to the platform yet, though. But you can change that by granting access once you’ve assigned this project. ",
        "setCustomerTitle": "Assign {customer} to {unit}?",
        "setVisibleMessage": "Splendid! You’re about to give {customer} full access to shared documents and information related to {unit}. ",
        "setVisibleTitle": "Give {customer} online access to {unit}?",
        "this": "this",
        "typeHere": "Type here...",
        "typeToConfirm": "Type \"{confirmationInput}\" to confirm",
        "warningAreYouSure": "CAREFUL! Are you sure?",
        "warningDeleteDocument": "{file_name} was uploaded in a {attachable_type}. Removing it here will also remove it from the {attachable_type}",
        "warningDeleteDocumentApprovedProposal": "{file_name} is a document belonging to an approved proposal and can't be deleted in this state. Deleting it would require reverting the approval of the proposal",
        "warningDeleteDocumentLevel": "{file_name} was uploaded in the {level_type} folder. Removing it here will also remove it from the {level_type} folder",
        "warningDeleteDocumentMulti": "Some of the documents you want to delete were uploaded in a decision or a conversation. Removing them here will also remove them from the decision or the conversation"
      }
    }
  }
}
